export default __webpack_public_path__ + "static/media/ThisAV.665ce897.png";